import { requestToken } from "../../../auth/AuthServices";
import HeaderFarms from "../../../utils/header_farms";
import API from "../../../services";
import { Report } from "notiflix";
import moment from "moment";

export const calculateFuelDeliveryPeriod = async (form) => {

  try {

    const formData = form.getFieldsValue()
    const receiveFuelTank = formData['fuel_truck']
    const issuedPeriodDateInput = formData['issued_period']

    if (!receiveFuelTank) return

    const accessToken = await requestToken();

    const payload = {
      receiveID: receiveFuelTank,
    };

    // Hanya kirim datePeriod jika online untuk menghindari cache miss di PWA
    if (navigator.onLine) {
      payload.datePeriod = issuedPeriodDateInput;
    }

    const latest = await API.CalculateIssuedPeriod(HeaderFarms(accessToken), payload);

    if (latest.data) {

      let lastDelivery = moment(latest.data.issued_period_date_to)
      const currentDate = moment();

      if (issuedPeriodDateInput && issuedPeriodDateInput[0]) {
        lastDelivery = issuedPeriodDateInput[0]
      }

      form.setFieldsValue({
        issued_period: [lastDelivery, currentDate],
        issued_period_before: latest.data.last_total_amount_issued,
        remaining_fuel_period: latest.data.remaining_fuel_period,
      });

    } else {

      form.setFieldsValue({
        issued_period_before: null,
        remaining_fuel_period: null,
      });
    }

  } catch (err) {
    console.error(err);
    Report.warning(
      "Oops.. something wrong calculate fuel issued",
      err.toString(),
      "Okay"
    );
  }
};

export const handleAmountSubmittedChange = (form) => {

  const remainingFuelTank = form.getFieldsValue()['remaining_fuel_period'];

  const flowmeterTotal = form.getFieldsValue()['flowmeter_total'];
  const totalCalculateWithRemaining = flowmeterTotal + Math.max(remainingFuelTank, 0)

  form.setFieldsValue({
    issued_total: totalCalculateWithRemaining,
  });
};